import { type IAIReceptionistKnowledgeBase } from '@principle-theorem/principle-core/interfaces';

/**
 * Returns the template IDs the practice has excluded from its knowledge base.
 *
 * An absent knowledge base or absent overrides yields an EMPTY set, i.e. zero
 * exclusions. This default is deliberate and safety-critical: a failed or
 * missing knowledge base read must never be interpreted as "exclude
 * everything", which would wipe the practice's bookable treatments and
 * derived service copy on the next push.
 */
export function getExcludedTemplateIds(
  knowledgeBase: IAIReceptionistKnowledgeBase | undefined
): Set<string> {
  if (!knowledgeBase?.templateOverrides) {
    return new Set<string>();
  }

  return new Set<string>(
    Object.entries(knowledgeBase.templateOverrides)
      .filter(([, override]) => override.excludedFromKnowledgeBase === true)
      .map(([templateId]) => templateId)
  );
}
